import { z } from 'zod';
import { iconCategorySchema, mapModeSchema, mapPositionSchema } from './map-object.js';
import { MAP_ARROW_MAX_POINTS, MAP_ARROW_MIN_POINTS } from '../map/arrow.js';

/** Hex color `#rrggbb` (lowercase or uppercase). */
export const hexColorSchema = z
  .string()
  .regex(/^#[0-9a-fA-F]{6}$/, 'color must be a hex string like #rrggbb');

export const arrowPointSchema = mapPositionSchema;
export type ArrowPointDTO = z.infer<typeof arrowPointSchema>;

export const arrowMetadataSchema = z.object({
  note: z.string().max(2000).optional(),
});
export type ArrowMetadataDTO = z.infer<typeof arrowMetadataSchema>;

const pointsSchema = z
  .array(arrowPointSchema)
  .min(MAP_ARROW_MIN_POINTS)
  .max(MAP_ARROW_MAX_POINTS);

export const mapArrowSchema = z.object({
  id: z.string().uuid(),
  kind: iconCategorySchema,
  points: pointsSchema,
  color: hexColorSchema.nullable(),
  arrowheadStart: z.boolean(),
  arrowheadEnd: z.boolean(),
  dashed: z.boolean(),
  metadata: arrowMetadataSchema,
  mode: mapModeSchema,
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable().optional(),
});
export type MapArrowDTO = z.infer<typeof mapArrowSchema>;

export const createMapArrowSchema = z.object({
  kind: iconCategorySchema,
  points: pointsSchema,
  color: hexColorSchema.nullable().optional(),
  arrowheadStart: z.boolean().optional(),
  arrowheadEnd: z.boolean().optional(),
  dashed: z.boolean().optional(),
  metadata: arrowMetadataSchema.optional(),
  mode: mapModeSchema.optional(),
});
export type CreateMapArrowInput = z.infer<typeof createMapArrowSchema>;

export const patchMapArrowSchema = z
  .object({
    kind: iconCategorySchema.optional(),
    points: pointsSchema.optional(),
    color: hexColorSchema.nullable().optional(),
    arrowheadStart: z.boolean().optional(),
    arrowheadEnd: z.boolean().optional(),
    dashed: z.boolean().optional(),
    metadata: arrowMetadataSchema.optional(),
    mode: mapModeSchema.optional(),
  })
  .refine((p) => Object.keys(p).length > 0, {
    message: 'Patch must include at least one field',
  });
export type PatchMapArrowInput = z.infer<typeof patchMapArrowSchema>;

export const listMapArrowsResponseSchema = z.object({
  arrows: z.array(mapArrowSchema),
});
export type ListMapArrowsResponse = z.infer<typeof listMapArrowsResponseSchema>;
